module.exports = __webpack_public_path__ + "src/img/delete.567564dd.svg";